<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.937"
    height="16.937"
    viewBox="0 0 16.937 16.937"
    class="icon icon--login"
  >
    <path
      fill="#ebebeb"
      d="M8.468,2.011a2.171,2.171,0,0,1,2.223,2.223A2.171,2.171,0,0,1,8.468,6.457,2.171,2.171,0,0,1,6.245,4.234,2.171,2.171,0,0,1,8.468,2.011m0,9.527c3.176,0,6.457,1.588,6.457,2.223v1.164H2.011V13.761c0-.635,3.282-2.223,6.457-2.223M8.468,0A4.234,4.234,0,1,0,12.7,4.234,4.247,4.247,0,0,0,8.468,0Zm0,9.527C5.61,9.527,0,10.9,0,13.761v3.176H16.937V13.761c0-2.858-5.61-4.234-8.468-4.234Z"
    ></path>
  </svg>
</template>

<script>
  export default {
    name: 'Login',
  };
</script>